module.exports = __webpack_public_path__ + "static/img/auth-error.8f0c1179.png";